/** EUR amounts are cents; explicit IRR prices are whole rials. */
export function promotionAmount(amount, currency = "EUR") {
  return new Intl.NumberFormat("fa-IR", { style: "currency", currency }).format(amount / (currency === "IRR" ? 1 : 100));
}
